// src/components/landing/scroll.js

/*
 * Rola até uma seção da landing. Fora da landing (seção inexistente),
 * volta para a home já ancorada na seção.
 */
export function scrollToSection(id) {
  const section = document.getElementById(id);

  if (section) {
    const reduce = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    section.scrollIntoView({
      behavior: reduce ? "auto" : "smooth",
      block: "start",
    });
    return;
  }

  window.location.href = `/#${id}`;
}
